module.exports = __webpack_public_path__ + "img/comprobantes64.fbd69f8a.png";